class SiteHamburger extends HTMLElement {
  constructor() {
    super();
    // document.addEventListener("DOMContentLoaded", () => {
      this.init();
    // });
  }
  init() {
    this.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      document.body.classList.toggle('js-menu-open');
      const menuOpen = document.body.classList.contains('js-menu-open');

      const header = document.querySelector('site-header');
      header?.showMobileMenu(menuOpen);
      if (!menuOpen) {
        header?.closeAllMobileSubMenu();
      }
    })
  }
}

if (!customElements.get('site-hamburger')) {
  customElements.define('site-hamburger', SiteHamburger);
}
